"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetRelative;

/**
  * Calculate the component's offset relative to the target.
  *
  * @param {Node|ReactElement} ref Reference to a DOM Node or React Element.
  * @param {Node|ReactElement} target Reference to a DOM Node or React Element that is contains ref.
  * @returns {Object} left and top offsets.
  * @public
  */
function offsetRelative(ref, target) {
  let left = ref.offsetLeft;
  let top = ref.offsetTop;
  let parent = ref.offsetParent;

  while (parent && parent !== target && target.contains(ref)) {
    left += parent.offsetLeft;
    top += parent.offsetTop;
    parent = parent.offsetParent;
  }

  return {
    left,
    top
  };
}